"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_BUCKET_DELETE_NOTE = exports.BUCKET_DELETE_MESSAGE = exports.EXTRA_PAYMENT_UNAVAILABLE = exports.EXTRA_PAYMENT_NONE = void 0;
exports.bucketDeleteMessage = bucketDeleteMessage;
/**
 * The Debt Eliminator's extra payment when no Forecast debt bucket drives it, and
 * the warning on deleting that bucket (BEN-141 FP-003).
 *
 * Web wrote these first (`frontend/src/lib/extraPayment.ts`,
 * `ForecastBucketDialog.tsx`, released with FP-003 in #1503); mobile adopted them
 * in the FP-003 follow, which moved them here so the two clients cannot word the
 * same $0 differently. The server sends `extra_payment_source` "none" ($0, no debt
 * bucket) or "unavailable" ($0, the forecast could not be read); it no longer
 * sends "suggested".
 */
/** The bucket's name follows Paul, 3 Nov ("Debt Eliminator", as on Forecast). */
exports.EXTRA_PAYMENT_NONE = "No extra payment: you don't have a Debt Eliminator bucket on Forecast. Add one there, or set your own amount.";
exports.EXTRA_PAYMENT_UNAVAILABLE = "Your Forecast couldn't be read just now, so no extra payment is applied. Try again in a moment.";
/** The delete confirmation for any Forecast bucket. */
exports.BUCKET_DELETE_MESSAGE = "This bucket will be removed and its share becomes unallocated. Your other buckets keep the percentages you set. Linked goals stay intact and become unlinked.";
/** Added for the debt bucket only: deleting it changes a figure on another page. */
exports.DEBT_BUCKET_DELETE_NOTE = "Unless you've set your own amount on the Debt Eliminator, your extra payment there comes from this bucket, so it becomes $0 until you add a debt bucket again.";
/** The whole confirmation sentence for a bucket, by its key. */
function bucketDeleteMessage(bucketKey) {
    return bucketKey === "debt"
        ? `${exports.BUCKET_DELETE_MESSAGE} ${exports.DEBT_BUCKET_DELETE_NOTE}`
        : exports.BUCKET_DELETE_MESSAGE;
}
//# sourceMappingURL=extraPaymentCopy.js.map